import http from "@/http";
import utils from "@/utils";
import { Controller } from "@hotwired/stimulus";
import { controlTag } from "./form-control-initializer";
import { FormControl } from "./form-manager";

export class NativeFormController extends Controller<HTMLFormElement> {

    private controls: FormControl[]; 

    initialize(): void {
        utils.addControllerAction(this, {method: 'submit:prevent'});
    }

    connect(): void {
        controlTag.getAll(this.element.querySelectorAll('.ww-field__control'))
            .then(controls => this.controls = controls);
    }

    submit() {
        let method = this.element.method;
        let url = http.withPageParams(this.element.action);
        let [action, data] = http.removeUrlParams(url); // GET requests don't preserve URL params, so include in data instead
        data.nonce = http.getNonce();
        data.variables = JSON.stringify(this.getVariables());
        http.sendSynchronousRequest({method, action, data});
    }

    private getVariables(): Record<string, any> {
        let variables: Record<string, any> = {};
        this.controls.forEach(control => {
            variables[control.getName()] = control.getValue();
        });
        return variables;
    }
}